import React from 'react';
import {
  FaPhoneAlt,
  FaVideo,
  FaCheck,
  FaTimes
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import '../css/CallModal.css';

function CallModal({
  isOpen,
  callData,
  onAccept,
  onReject
}) {
  const { t } = useTranslation();

  if (!isOpen || !callData) {
    return null;
  }

  const isVideoCall =
    String(callData.type).toLowerCase() === 'video';

  const callerName =
    callData.callerName ||
    callData.name ||
    t('call.someone', 'Someone');

  return (
    <div
      className="call-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={t(
        'call.incomingCall',
        'Incoming call'
      )}
    >
      <div
        className={`call-modal ${
          isVideoCall
            ? 'video-call'
            : 'audio-call'
        }`}
      >
        <div className="call-modal-glow" />

        <div className="call-icon-wrapper">
          <div className="call-icon-pulse pulse-one" />
          <div className="call-icon-pulse pulse-two" />

          <div className="call-main-icon">
            {isVideoCall ? (
              <FaVideo />
            ) : (
              <FaPhoneAlt />
            )}
          </div>
        </div>

        <span className="call-status">
          {t(
            'call.incoming',
            'Incoming call'
          )}
        </span>

        <h2 className="call-title">
          {isVideoCall
            ? t('call.videoCall', 'Video call')
            : t('call.audioCall', 'Audio call')}
        </h2>

        <p className="call-caller-name">
          {callerName}
        </p>

        <div className="call-ringing-animation">
          <span />
          <span />
          <span />
          <span />
        </div>

        <div className="call-modal-buttons">
          <div className="call-action">
            <button
              type="button"
              className="call-button reject-btn"
              onClick={onReject}
              aria-label={t(
                'call.reject',
                'Reject'
              )}
            >
              <FaTimes />
            </button>

            <span>
              {t('call.reject', 'Reject')}
            </span>
          </div>

          <div className="call-action">
            <button
              type="button"
              className="call-button accept-btn"
              onClick={onAccept}
              aria-label={t(
                'call.accept',
                'Accept'
              )}
            >
              <FaCheck />
            </button>

            <span>
              {t('call.accept', 'Accept')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CallModal;